import { Misc } from '../../';
import AnimationHelper from '../AnimationHelper';
var inactiveClassName = "inactive";
var ModalHelper = /** @class */ (function () {
    function ModalHelper(props, container) {
        var _this = this;
        var _a;
        this.modals = [];
        this.rootClassName = "";
        this.rootClassName = (_a = props.className) !== null && _a !== void 0 ? _a : "";
        this.rootContainer = document.createElement("div");
        this.rootContainer.className = this.rootClassName;
        this.rootContainer.tabIndex = -1;
        (container !== null && container !== void 0 ? container : Misc.Globals.rootElement).appendChild(this.rootContainer);
        // Create the container for all the modals
        var modalsContainer = document.createElement("div");
        modalsContainer.className = "modal fade";
        modalsContainer.tabIndex = -1;
        modalsContainer.addEventListener("mousedown", this.onContainerClick.bind(this));
        modalsContainer.addEventListener("keydown", function (key) {
            if (key.key === "Escape") {
                if (_this.modals.length > 0) {
                    var lastModel = _this.modals[_this.modals.length - 1];
                    if (lastModel.onDismiss)
                        lastModel.onDismiss(undefined);
                }
            }
        });
        this.modalsContainer = modalsContainer;
        this.rootContainer.appendChild(modalsContainer);
        // Create the full screen backdrop
        var backdrop = document.createElement("div");
        backdrop.className = "modal-backdrop fade";
        backdrop.style.display = "none";
        this.modalsBackdrop = backdrop;
        this.rootContainer.appendChild(backdrop);
    }
    Object.defineProperty(ModalHelper, "appInstance", {
        get: function () {
            if (!ModalHelper._instance) {
                throw Error("ModalHelper is not initialised. Make sure your app contains a ModalContainer component.");
            }
            return ModalHelper._instance;
        },
        enumerable: false,
        configurable: true
    });
    ModalHelper.initialise = function (props, container) {
        if (!ModalHelper._instance) {
            ModalHelper._instance = new ModalHelper(props, container);
        }
    };
    ModalHelper.prototype.updateProps = function (props) {
        var _a;
        this.rootClassName = (_a = props.className) !== null && _a !== void 0 ? _a : "";
    };
    ModalHelper.prototype.addModal = function (modal, options, onDismiss) {
        modal.className = "modal-container";
        // Create backdrop to prevent interaction with non top-level modals
        var modalOverlay = document.createElement("div");
        modalOverlay.className = "modal-container-backdrop";
        modal.appendChild(modalOverlay);
        if (document.activeElement)
            document.activeElement.blur();
        this.makeModalsInactive();
        this.endModalAnimations();
        var hasVisibleModal = this.modals.find(function (m) { return !m.isRemoving; });
        var modalInstance = { container: modal, onDismiss: onDismiss, isRemoving: false };
        this.modals.push(modalInstance);
        if (!hasVisibleModal) {
            this.addFirstModal(modal, options);
        }
        else {
            this.insertAdditionalModal(modal);
        }
        modal.tabIndex = -1;
        modal.focus();
        return modalInstance;
    };
    ModalHelper.prototype.addFirstModal = function (modal, options) {
        this.modalsContainer.appendChild(modal);
        if (document.body.scrollHeight > window.innerHeight && document.body.clientWidth > 768) {
            document.body.classList.add("has-modal-scroll-fix");
        }
        document.body.classList.add("has-modal");
        this.modalsContainer.classList.remove("modal-scroll-fix");
        this.modalsContainer.style.display = "block";
        this.modalsBackdrop.style.display = "block";
        AnimationHelper.triggerReflow(this.modalsContainer);
        this.modalsContainer.classList.add("show");
        this.modalsBackdrop.classList.add("show");
        if (options.containerClassName) {
            this.rootContainer.classList.add(options.containerClassName);
        }
    };
    ModalHelper.prototype.insertAdditionalModal = function (modal) {
        this.modalsContainer.insertBefore(modal, this.modalsContainer.childNodes[0]);
        var marginTop = parseInt(window.getComputedStyle(modal.children[0]).marginTop);
        modal.style.marginTop = -(modal.clientHeight + marginTop) + "px";
        AnimationHelper.triggerReflow(this.modalsContainer);
        modal.classList.add("modal-container-additional");
        AnimationHelper.triggerReflow(this.modalsContainer);
        modal.style.marginTop = "0";
        modal.classList.add("show");
        this.modalsContainer.scrollTo(0, 0);
    };
    ModalHelper.prototype.beginRemove = function (modal) {
        if (!modal.isRemoving) {
            modal.isRemoving = true;
            if (this.modals.every(function (m) { return m.isRemoving; })) {
                // All modals are closing.
                // Cancel any pending closing slide animations, since all modals are now being closed using the main animation.
                this.cancelModalSlides();
                // Remove the backdrop and top level container.
                this.modalsContainer.classList.remove("show");
                this.modalsBackdrop.classList.remove("show");
                this.rootContainer.className = this.rootClassName;
                document.body.classList.remove("has-modal", "has-modal-scroll-fix");
                if (document.body.scrollHeight > window.innerHeight) {
                    // Prevent modal jumping left when showing scrollbar.
                    this.modalsContainer.classList.add("modal-scroll-fix");
                }
            }
            else {
                // Otherwise just fade the current modal
                modal.container.classList.remove("show");
                var marginTop_1 = parseInt(window.getComputedStyle(modal.container.children[0]).marginTop);
                modal.fadeTimer = setTimeout(function () { return modal.container.style.marginTop = -(modal.container.clientHeight + marginTop_1) + "px"; }, 0);
                this.modals[this.modals.length - 2].container.classList.remove(inactiveClassName);
            }
        }
    };
    ModalHelper.prototype.endRemove = function (modal) {
        // call again in case the modal was destroyed without being closed by the user.
        this.beginRemove(modal);
        this.modalsContainer.removeChild(modal.container);
        this.modals.splice(this.modals.indexOf(modal), 1);
        if (this.modalsContainer.childNodes.length == 0) {
            this.modalsContainer.style.display = "none";
            this.modalsBackdrop.style.display = "none";
        }
    };
    ModalHelper.prototype.endModalAnimations = function () {
        for (var _i = 0, _a = this.modals.filter(function (m) { return m.isRemoving; }); _i < _a.length; _i++) {
            var modal = _a[_i];
            modal.container.style.display = "none";
        }
    };
    ModalHelper.prototype.makeModalsInactive = function () {
        for (var _i = 0, _a = this.modals; _i < _a.length; _i++) {
            var modal = _a[_i];
            modal.container.classList.add(inactiveClassName);
        }
    };
    ModalHelper.prototype.cancelModalSlides = function () {
        for (var _i = 0, _a = this.modals; _i < _a.length; _i++) {
            var modal = _a[_i];
            if (modal.fadeTimer) {
                clearTimeout(modal.fadeTimer);
            }
        }
    };
    ModalHelper.prototype.onContainerClick = function (e) {
        if (this.modals.length == 1) {
            var modal = this.modals[this.modals.length - 1];
            if (e.target == this.modalsContainer || e.target == modal.container) {
                if (modal.onDismiss)
                    modal.onDismiss(e);
            }
        }
    };
    return ModalHelper;
}());
export default ModalHelper;
